import styled from "styled-components";
import { devices } from "../../utilities/responsive";

export const CategoriesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 10px;
  border-top: 1px solid rgb(75, 79, 90);
  margin-top: 3em;

  h6 {
    width: 100%;

    @media ${devices.tabletPortrait} {
      font-size: 1.6rem;
    }
  }

  a {
    &:hover {
      color: var(--white);
    }
  }
`;
